<template>
  <div class="accounts-mobile-fields-multiple-search-input">
    <ui-search-input
      v-model="searchValue"
      class="accounts-mobile-fields-multiple-search-input__search"
      size="extra-small"
      placeholder="Search" />

    <div class="accounts-mobile-fields-multiple-search-input__results">
      <div
        v-for="(item) in visibleSearchResults"
        :key="item.id"
        class="accounts-mobile-fields-multiple-search-input__result"
        @click="selectItem(item)">
        <img
          v-show="item.image"
          width="28"
          height="28"
          :src="item.image"
          alt=""
          class="accounts-mobile-fields-multiple-search-input__result-image">

        <span
          class="accounts-mobile-fields-multiple-search-input__result-title"
          :title="item.value">
          {{ item.value }}
        </span>

        <ui-checkbox
          class="accounts-mobile-fields-multiple-search-input__result-checkbox"
          :value="isItemChecked(item)"
          @input="selectItem(item)" />
      </div>

      <div
        v-if="hasMoreResults"
        v-intersected="{
          handler: loadMoreResults
        }"
        class="accounts-mobile-fields-multiple-search-input__load-more">
        Loading more...
      </div>
    </div>
  </div>
</template>

<script>
import { _debounce as debounce } from 'Root/helpers/tools';
import UiSearchInput from 'Components/ui/Input/UiSearchInput.vue';
import UiCheckbox from 'Components/ui/Checkbox/UiCheckbox.vue';
import intersectedDirective from 'Root/directives/intersectedDirective';

export default {
  name: 'AccountsMobileFieldsMultipleSearchInput',
  components: { UiCheckbox, UiSearchInput },

  directives: {
    ...intersectedDirective,
  },

  props: {
    searchResults: {
      type: Array,
      default: () => [],
    },

    values: {
      type: Array,
      default: () => [],
    },

    isRadio: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchValue: '',
      currentValues: [],

      visibleResults: 10,
      isLoading: false,
    };
  },

  computed: {
    visibleSearchResults() {
      return this.searchResults.slice(0, this.visibleResults);
    },

    hasMoreResults() {
      return this.visibleResults < this.searchResults.length;
    },
  },

  watch: {
    searchValue: {
      handler(newValue) {
        this.emitSearch(newValue);
      },
    },
  },

  created() {
    this.currentValues = [...this.values];
  },

  methods: {
    selectItem(item) {
      if (this.isRadio) {
        this.currentValues = [item];
      } else {
        if (this.isItemChecked(item)) {
          this.currentValues = this.currentValues.filter((value) => JSON.stringify(value) !== JSON.stringify(item));
          return;
        }
        this.currentValues.push(item);
      }
      this.emitValues();
    },

    isItemChecked(item) {
      return this.currentValues.some((value) => JSON.stringify(value) === JSON.stringify(item));
    },

    // eslint-disable-next-line func-names
    emitSearch: debounce(function (value) {
      this.resetVisibleResults();
      this.$emit('search', value);
    }, 1000),

    emitValues() {
      this.$emit('input', this.currentValues);
    },

    resetVisibleResults() {
      this.visibleResults = 10;
    },

    loadMoreResults(entries) {
      if (entries[0].isIntersecting && !this.isLoading && this.hasMoreResults) {
        this.isLoading = true;
        setTimeout(() => {
          this.visibleResults += 10;
          this.isLoading = false;
        }, 500);
      }
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .ui-search-input {
  --font-color: $color--basic-white;

  background-color: #{rgba($color--basic-blue, 0.25)};
  opacity: 1;

  .ui-search-input__icon {
    background-color: $color--basic-white;
  }
}

.accounts-mobile-fields-multiple-search-input__results {
  overflow: auto;
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  max-height: 308px;
}

.accounts-mobile-fields-multiple-search-input__result {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid $color--basic-menu;

  .accounts-mobile-fields-multiple-search-input__result-checkbox {
    margin-left: auto;
    flex-shrink: 0;

    --size: 20px;
    --check-size: 10px;
    --bg-color: #5F73FA40;
    --bg-color-checked: linear-gradient(270deg, #5F73FA 0%, #7B61FF 100%);
    --check-color: #{$color--basic-white};
    --border-radius: 3px;

    /deep/ .ui-checkbox-box {
      margin-right: 0;
    }
  }
}

.accounts-mobile-fields-multiple-search-input__result-image {
  width: 28px;
  height: 28px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}

.accounts-mobile-fields-multiple-search-input__result-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  color: $color--basic-white;
}

.accounts-mobile-fields-multiple-search-input__load-more {
  margin-top: 12px;
  font-size: 13px;
  color: $color--basic-white;
}
</style>
